import { useNavigate } from "react-router-dom";

/**
 * Envolve um card/linha e navega para a memória de cálculo do `cardKey` ao clicar,
 * opcionalmente com janela de período (?periodFrom&periodTo, ISO) e grupo
 * pré-expandido (?group=). cardKey null = elemento não clicável (valor derivado).
 */
export function MemoryLink({
  cardKey, periodFrom, periodTo, group, children, className,
}: {
  cardKey: string | null;
  periodFrom?: string | null;
  periodTo?: string | null;
  group?: string | null;
  children: React.ReactNode;
  className?: string;
}) {
  const navigate = useNavigate();
  if (!cardKey) return <div className={className ?? "cursor-default"}>{children}</div>;

  const params = new URLSearchParams();
  if (periodFrom && periodTo) {
    params.set("periodFrom", periodFrom);
    params.set("periodTo", periodTo);
  }
  if (group) params.set("group", group);
  const qs = params.toString() ? `?${params.toString()}` : "";

  return (
    <div
      className={className ?? "cursor-pointer"}
      onClick={() => navigate(`/financeiro/memoria/${cardKey}${qs}`)}
      title="Clique para ver a memória de cálculo e os documentos"
    >
      {children}
    </div>
  );
}
